import { DbRef } from "./firebase";
export var SampleType;
(function (SampleType) {
    SampleType["DISCHARGE"] = "discharge";
    SampleType["DRAINAGE"] = "drainage";
    SampleType["MUCUS"] = "mucus";
    SampleType["PLASMA"] = "plasma";
    SampleType["SALIVA"] = "saliva";
    SampleType["SERUM"] = "serum";
    SampleType["WHOLE_BLOOD"] = "wholeBlood";
})(SampleType || (SampleType = {}));
export const tubeSampleTypes = {
    [SampleType.PLASMA]: true,
    [SampleType.SERUM]: true,
    [SampleType.WHOLE_BLOOD]: true,
};
export const pcrSampleTypes = {
    [SampleType.DISCHARGE]: true,
    [SampleType.DRAINAGE]: true,
    [SampleType.MUCUS]: true,
    [SampleType.SALIVA]: true,
    [SampleType.WHOLE_BLOOD]: true,
};
export var SampleStatus;
(function (SampleStatus) {
    SampleStatus["PENDING"] = "pending";
    /** Nurse has marked the sample as collected/tube as filled. */
    SampleStatus["COLLECTED"] = "collected";
    /**
     * Nurse has marked the sample as failed/tube as not filled.
     *
     * TODO: rename to collectionFailed
     */
    SampleStatus["FAILED"] = "failed";
    /** Nurse has marked the sample drop-off as failed */
    SampleStatus["DROP_OFF_FAILED"] = "dropOffFailed";
    /**
     * Nurse has marked the sample as dropped off (drop off and sample completion
     * by lab may be expanded to two distinct statuses in the future)
     *
     * or
     *
     * Nurse has marked the sample with instruction `discardAfterTransfer` as
     * discarded.
     */
    SampleStatus["COMPLETED"] = "completed";
    /* The procedure has been canceled */
    SampleStatus["CANCELED"] = "canceled";
})(SampleStatus || (SampleStatus = {}));
export var GenericCollectionFailureReason;
(function (GenericCollectionFailureReason) {
    GenericCollectionFailureReason["INSUFFICIENT_SPECIMEN_COLLECTED"] = "insufficientSpecimenCollected";
    GenericCollectionFailureReason["PATIENT_UNABLE_TO_PRODUCE_SPECIMEN"] = "patientUnableToProduceSpecimen";
    GenericCollectionFailureReason["PATIENT_UNCOOPERATIVE"] = "patientUncooperative";
    GenericCollectionFailureReason["SUPPLY_FAILURE"] = "supplyFailure";
})(GenericCollectionFailureReason || (GenericCollectionFailureReason = {}));
export const genericCollectionFailureReasonLabels = {
    [GenericCollectionFailureReason.INSUFFICIENT_SPECIMEN_COLLECTED]: 'Insufficient specimen collected',
    [GenericCollectionFailureReason.PATIENT_UNABLE_TO_PRODUCE_SPECIMEN]: 'Patient unable to produce specimen',
    [GenericCollectionFailureReason.PATIENT_UNCOOPERATIVE]: 'Patient uncooperative',
    [GenericCollectionFailureReason.SUPPLY_FAILURE]: 'Supply failure',
};
export var TubeCollectionFailureReason;
(function (TubeCollectionFailureReason) {
    TubeCollectionFailureReason["UNABLE_TO_ACCESS_THE_VEIN"] = "unableToAccessTheVein";
    TubeCollectionFailureReason["INSUFFICIENT_QUANTITY"] = "insufficientQuantity";
    TubeCollectionFailureReason["LOST_VENOUS_ACCESS_BLOOD_FLOW_STOPPED"] = "lostVenousAccessBloodFlowStopped";
    TubeCollectionFailureReason["TUBE_MALFUNCTION"] = "tubeMalfunction";
    TubeCollectionFailureReason["PATIENT_REQUEST"] = "patientRequest";
})(TubeCollectionFailureReason || (TubeCollectionFailureReason = {}));
export const tubeCollectionFailureReasonLabels = {
    [TubeCollectionFailureReason.UNABLE_TO_ACCESS_THE_VEIN]: 'Unable to access the vein',
    [TubeCollectionFailureReason.INSUFFICIENT_QUANTITY]: 'Insufficient quantity',
    [TubeCollectionFailureReason.LOST_VENOUS_ACCESS_BLOOD_FLOW_STOPPED]: 'Lost venous access/Blood flow stopped',
    [TubeCollectionFailureReason.TUBE_MALFUNCTION]: 'Tube malfunction',
    [TubeCollectionFailureReason.PATIENT_REQUEST]: 'Patient request',
};
export var GenericDropOffFailureReason;
(function (GenericDropOffFailureReason) {
    GenericDropOffFailureReason["INSUFFICIENT_QUANTITY_RECEIVED"] = "insufficientQuantityReceived";
    GenericDropOffFailureReason["WRONG_TUBE_TYPE_CONTAINER"] = "wrongTubeTypeContainer";
    GenericDropOffFailureReason["REQUISITION_FORM_ISSUE"] = "requisitionFormIssue";
})(GenericDropOffFailureReason || (GenericDropOffFailureReason = {}));
export const genericDropOffFailureReasonLabels = {
    [GenericDropOffFailureReason.INSUFFICIENT_QUANTITY_RECEIVED]: 'Insufficient quantity received',
    [GenericDropOffFailureReason.WRONG_TUBE_TYPE_CONTAINER]: 'Wrong tube type/container',
    [GenericDropOffFailureReason.REQUISITION_FORM_ISSUE]: 'Requisition form issue',
};
export var TubeDropOffFailureReason;
(function (TubeDropOffFailureReason) {
    TubeDropOffFailureReason["LAB_DECLINES_TUBE_INCORRECT_TUBE_TYPE"] = "labDeclinesTubeIncorrectTubeType";
    TubeDropOffFailureReason["SPECIMEN_GROSSLY_HEMOLYZED"] = "specimenGrosslyHemolyzed";
    TubeDropOffFailureReason["MISSING_OR_INCORRECT_INFO_PROVIDED"] = "missingOrIncorrectInfoProvided";
    TubeDropOffFailureReason["UNABLE_TO_GAIN_ACCESS_TO_LAB"] = "unableToGainAccessToLab";
    TubeDropOffFailureReason["EXCESSIVE_WAIT_TIME"] = "excessiveWaitTime";
    TubeDropOffFailureReason["REQUISITION_ISSUE"] = "requisitionIssue";
})(TubeDropOffFailureReason || (TubeDropOffFailureReason = {}));
export const tubeDropOffFailureReasonLabels = {
    [TubeDropOffFailureReason.LAB_DECLINES_TUBE_INCORRECT_TUBE_TYPE]: 'Lab declines tube / incorrect tube type',
    [TubeDropOffFailureReason.SPECIMEN_GROSSLY_HEMOLYZED]: 'Specimen grossly hemolyzed',
    [TubeDropOffFailureReason.MISSING_OR_INCORRECT_INFO_PROVIDED]: 'Missing or incorrect info provided',
    [TubeDropOffFailureReason.UNABLE_TO_GAIN_ACCESS_TO_LAB]: 'Unable to gain access to lab',
    [TubeDropOffFailureReason.EXCESSIVE_WAIT_TIME]: 'Excessive wait time',
    [TubeDropOffFailureReason.REQUISITION_ISSUE]: 'Requisition issue',
};
export const sampleDropOffFailureReasonLabels = Object.assign(Object.assign({}, genericDropOffFailureReasonLabels), tubeDropOffFailureReasonLabels);
/**
 * Sample check items not included as processing instructions in
 * `SupplyInstructionOptions`
 */
export var NonProcessingSampleCheckItem;
(function (NonProcessingSampleCheckItem) {
    NonProcessingSampleCheckItem["COLLECTED"] = "collected";
    NonProcessingSampleCheckItem["DROPPED_OFF"] = "droppedOff";
})(NonProcessingSampleCheckItem || (NonProcessingSampleCheckItem = {}));
export const SampleRelationshipKeys = {
    placeID: { ref: DbRef.PLACES },
    procedureID: { ref: DbRef.PROCEDURES },
    productIDs: { ref: DbRef.PRODUCTS },
    supplyID: { ref: DbRef.SUPPLIES },
    supplyItemID: { ref: DbRef.SUPPLY_ITEMS },
};
export var SamplesDeliveryType;
(function (SamplesDeliveryType) {
    /**
     * Associated with shipment of samples to a lab (i.e. via FedEx)
     */
    SamplesDeliveryType["MAIL_IN"] = "mailIn";
    /**
     * Associated with in-person delivery of samples to a lab (i.e. by the nurse)
     */
    SamplesDeliveryType["WALK_IN"] = "walkIn";
})(SamplesDeliveryType || (SamplesDeliveryType = {}));
//# sourceMappingURL=sample.js.map